import { InjectionToken } from '@angular/core';

export const OVERLAY_LEVEL = new InjectionToken<number>('overlayLevel', {
  providedIn: 'root',
  /**
   * This have to be in sync with CDK $overlay-z-index variable
   */
  factory: () => 9000,
});
